export const FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED = 'FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED'
export const FETCH_QUESTIONS_SUCCEEDED = 'FETCH_QUESTIONS_SUCCEEDED'
export const DELETE_QUESTION_SUCCEEDED = 'DELETE_QUESTION_SUCCEEDED'
